import React from 'react';
import { images } from '../mock';

const InnerPageHero = ({ title, description, badge }) => {
  return (
    <section className="relative py-32 overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${images.services})`,
        }}
      ></div>
      
      {/* Overlay with gradient - darker for better text contrast */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#E2F8FE]/90 via-[#B5E7FA]/85 to-[#E2F8FE]/90"></div>
      
      {/* Animated decorative elements */}
      <div className="absolute inset-0 overflow-hidden opacity-10">
        <div className="absolute top-[10%] left-[5%] w-32 h-32 bg-[#FF4A2A] rounded-full blur-3xl animate-float"></div>
        <div className="absolute top-[20%] right-[10%] w-40 h-40 bg-white rounded-full blur-3xl animate-float-delayed"></div>
        <div className="absolute top-[50%] left-[15%] w-24 h-24 bg-[#FF4A2A] rounded-full blur-2xl animate-pulse-slow"></div>
        <div className="absolute top-[60%] right-[20%] w-36 h-36 bg-white rounded-full blur-3xl animate-float-slow"></div>
        <div className="absolute bottom-[10%] left-[30%] w-28 h-28 bg-[#FF4A2A] rounded-full blur-2xl animate-float"></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center space-y-8">
          {badge && (
            <div className="inline-block animate-fade-in">
              <span className="bg-white text-[#FF4A2A] px-6 py-3 rounded-full text-sm font-bold border-2 border-[#FF4A2A] shadow-xl uppercase tracking-wide">
                {badge}
              </span>
            </div>
          )}
          <h1 className="text-5xl md:text-7xl font-bold text-gray-900 leading-tight drop-shadow-lg animate-fade-in-up">
            {title}
          </h1>
          <p className="text-xl md:text-2xl text-gray-800 max-w-4xl mx-auto leading-relaxed font-medium animate-fade-in-up-delay">
            {description}
          </p>
          
          {/* Call to Action Stats */}
          <div className="flex flex-wrap justify-center gap-8 pt-6">
            <div className="bg-white/80 backdrop-blur-sm px-6 py-4 rounded-xl shadow-lg">
              <div className="text-3xl font-bold text-[#FF4A2A]">95%</div>
              <div className="text-sm text-gray-700 font-medium">Success Rate</div>
            </div>
            <div className="bg-white/80 backdrop-blur-sm px-6 py-4 rounded-xl shadow-lg">
              <div className="text-3xl font-bold text-[#FF4A2A]">24/7</div>
              <div className="text-sm text-gray-700 font-medium">Support</div>
            </div>
            <div className="bg-white/80 backdrop-blur-sm px-6 py-4 rounded-xl shadow-lg">
              <div className="text-3xl font-bold text-[#FF4A2A]">500+</div>
              <div className="text-sm text-gray-700 font-medium">Clients</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InnerPageHero;